/*
 *
 * CostsDebitDetailsDownloadModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 20-Aug-2025
*/

import CostsDebitDetailsDownloadModal from './CostsDebitDetailsDownloadModalContainer'

export default CostsDebitDetailsDownloadModal
